import { Tab } from '@syncfusion/ej2-navigations';
/**
 * `Tab renderer` module is used to render Tab control in BlockEditor.
 *
 * @hidden
 */
export class TabRenderer {
    constructor(editor) {
        this.editor = editor;
    }
    /**
     * Renders the tab control in BlockEditor.
     *
     * @param {ITabRendererOptions} args - specifies the arguments.
     * @returns {Tab} - returns the tab object.
     * @hidden
     */
    renderTab(args) {
        return new Tab({
            items: args.items,
            selectedItem: args.selectedItem,
            enableRtl: this.editor.enableRtl,
            cssClass: args.cssClass,
            selected: args.selected
        }, args.element);
    }
}
